/**
 * List Module
 * Pack of all list components and services
 **/

//Core
import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GenericModule} from './generic.module';
import {UIModule} from '../ui/ui.module';
import {AirModule} from './air.module';
import {PersonModule} from './person.module';
// import { FormBuilderModule } from './formbuilder/form-builder.module';

//Components
import {ListSelectComponent} from '../component/listselect/listselect.component';

//Service
import {SelectService} from '../service/select/select.service';
import {PipesModule} from '../pipes/pipes.module';
import {ListComponentModule} from '../component/list/listComponent.module';
import {TravellerComponentModule} from '../component/traveller/travellerComponent.module';
import {TravellerSynchronymeComponentModule} from '../component/travellersynchronyme/travellersynchronymeComponent.module';
import {ListComponent} from "../component/list/list.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";


@NgModule({
    imports: [
        CommonModule,
        UIModule,
        AirModule,
        PersonModule,
        PipesModule,
        ListComponentModule,
        TravellerComponentModule,
        TravellerSynchronymeComponentModule,
        FontAwesomeModule,
    ],
    declarations: [
        ListSelectComponent,
    ],
    exports: [
        ListSelectComponent,
        ListComponent,
    ],
    bootstrap: [],
    providers: [
        SelectService
    ]
})
export class ListModule {
}
